import moment from "moment";
import {
  formatTripDistance,
  formatTripDuration,
  getTripPrice,
} from "helper/trips";

import {
  CREATED_AT,
  DATE_BEGIN,
  DATE_END,
  DRIVER,
  DURATION,
  PRICE,
  DISTANCE,
  TAXI,
  MY_TRIPS,
} from "Constant";
export const COLUMNS = [
  {
    name: DRIVER,
    body: (data) => data.driver,
    // driver_image
  },
  {
    name: TAXI,
    selector: "taxi",
    // body: (data) => data.taxi,
    // driver_image
  },
  {
    name: DATE_BEGIN,
    body: (data) => {
      return data.date_begin.split("+")[0];
    },
  },
  {
    name: DATE_END,
    body: (data) => {
      return data.end_at.split("+")[0];
    },
  },
  {
    name: PRICE,
    body: (data) => getTripPrice(data.total_price),
  },
  {
    name: DURATION,
    body: (data) => formatTripDuration(data.time_spend_millisecond),
  },
  {
    name: DISTANCE,
    body: (data) => formatTripDistance(data.traveled_distance_meters),
  },
];

export const oneWeekBefore = moment().subtract(7, "days").toDate();
